import { Box, Skeleton } from '@mui/material'
import { DraggableEmrSectionList } from './DraggableEmrSectionList'
import { EmrReportSettingsForm } from './EmrReportSettingsForm'

export const EmrReportTab = ({
  emrEditorProperties,
  onSectionToggle,
  onPrintableToggle,
  onSectionPrintOnlyEditorOnlyChange,
  onReorder,
  reportType,
  metaEmrReportTypes,
  categories,
  tabOptions,
  onFieldUpdate,
  hideReportsTabsRelatedActions = false,
  hideEmrSectionHeader = false,
  hidePrintOnlyEditorOnlyToggles = false,
  hideReordering = false,
  sectionSubsectionsMap = {},
  expandedSections = new Set(),
  toggleSectionExpansion,
  toggleSubsectionExclusion,
  toggleSubsectionPrintable,
  fetchSectionEffectiveLayout,
  loading = false,
}) => {
  const { emrSections = [], extraExcludedSubSectionsInSections = {} } = emrEditorProperties || {}

  const getReportTypeDisplayName = (type) => {
    const displayNames = {
      prescription: 'Prescription',
      'therapy-report': 'Therapy Report',
      'screening-report': 'Screening Report',
    }
    return displayNames[type] || type
  }

  if (loading && !emrSections.length) {
    return (
      <Box className="pt-4" sx={{ px: 0 }}>
        <Box sx={{ textAlign: 'center', color: 'text.secondary', mb: 2 }}>
          Loading the sections…
        </Box>
        <Skeleton variant="text" width="80%" height={32} sx={{ mb: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ mb: 1.5, borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ mb: 1.5, borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ mb: 1.5, borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ mb: 1.5, borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
      </Box>
    )
  }

  if (!emrSections.length) {
    return (
      <div className="pt-4 text-center text-muted">
        <p>No EMR sections available for {getReportTypeDisplayName(reportType)}</p>
      </div>
    )
  }

  return (
    <div className="pt-2 w-100">
      {!hideReportsTabsRelatedActions && (
        <EmrReportSettingsForm
          emrEditorProperties={emrEditorProperties}
          metaEmrReportTypes={metaEmrReportTypes}
          categories={categories}
          tabOptions={tabOptions}
          onFieldUpdate={onFieldUpdate}
          reportTypeId={reportType}
        />
      )}
      {!hideEmrSectionHeader && <h4>EMR Sections</h4>}
      {emrSections.length > 0 && (
        <DraggableEmrSectionList
          emrSections={emrSections}
          onDragEnd={onReorder}
          onSectionToggle={onSectionToggle}
          onPrintableToggle={onPrintableToggle}
          onSectionPrintOnlyEditorOnlyChange={onSectionPrintOnlyEditorOnlyChange}
          hidePrintOnlyEditorOnlyToggles={hidePrintOnlyEditorOnlyToggles}
          hideReordering={hideReordering}
          reportType={reportType}
          sectionSubsectionsMap={sectionSubsectionsMap}
          expandedSections={expandedSections}
          onToggleExpansion={toggleSectionExpansion}
          onToggleSubsectionExclusion={toggleSubsectionExclusion}
          onToggleSubsectionPrintable={toggleSubsectionPrintable}
          extraExcludedSubSectionsInSections={extraExcludedSubSectionsInSections}
          fetchSectionEffectiveLayout={fetchSectionEffectiveLayout}
        />
      )}
    </div>
  )
}
